<template>
  <div>
    <el-card class="box-card">
      <p class="text-indent">
        作为一个专业的GIS开发者，虽然招聘需求很旺盛，但在实际开发中并不是很顺利，由于现在GIS主要是数据的可视化，在系统中的只占很小一部分，基本都是业务系统中的功能点，
        所以GIS开发人员需要承担其他非GIS专业的开发任务，另外由于团队中GIS开发不会很多（基本2~3人），所以还会带来沟通问题，你会深深发现对计算机开发技术的知识极度缺乏。
        没有专业的计算机知识很多工作无法胜任，或者说不能够很好的完成开发任务。
      </p>
      <p class="text-indent">
        在工作中，必然会学习其他的开发技术，比如开发前端的ui页面和后台的数据库交互接口，慢慢掌握比如数据库的通讯原理、系统的架构设计、软件的开发方式等等，
        坚持工作下来的GIS开发者很多都会在工作的过程中转变成了后端的JAVA开发者，或者成为前端WEB开发工程师，到后期会有更多人抛弃了单纯的GIS开发，因为发现了更为广阔的天地。


      </p>
      <p class="text-indent">
        但是进步不是那麽容易的事，对于GIS工作者来说，很多知识需要通过自学才能够掌握，还会浪费我们很多时间，带来的效果并不一定好,贵在坚持。所以为了更好的分享和学习，我搭建了这个网站，
        用来分享一些我工作和学习中所使用到的一些示例。部分示例不是免费的，需要付费购买，毕竟世界上没有免费的午餐，没有持续的回馈也是不可持续的，免费的午餐才是最贵的。
      </p>
      <p class="text-indent">
        举个栗子：
        比如我们需要开发一个功能，往往我们都会在百度上搜索类似的功能，然后再抄（必须的）网上公开的代码，但是有很大一部分代码是不能够正确运行的，所以又再一次踏上百度。
        这在无形中浪费了我们很多的开发时间，降低了开发的效率，然后就是加班搞。平时要注意积累，积累才能慢慢的提高。
      </p>
      <br>
      <p class="text-indent">
        本网站分享的所有示例，都经过测试可以正常运行的代码，希望在以后的日子里和大家一起进步，一起努力。提高我们GIS从业者的开发技能。
      </p>
      <p class="text-indent">
        包括但不限于：Springboot项目、SSM框架项目、大文件分块上传、多数据源、动态数据源、基于CAS的SSO,基于Euerka+Feign的微服务、基于Spring Security的静态权限、基于Spring Security的实时权限、
        TCP/UDP通信、Camunda工作流、定时任务调度、spark+hadoop的集成开发、GeoTools分析组件、vue+cesium、vue+openlayers等等
      </p>


    </el-card>
    <el-card style="position: absolute;bottom: 5px;width: 100%">
      <el-row>
        <el-col :xs="12" :sm="12" class="text-center">
          <p>反馈信息/联系我：<span style="color: #409EFF">zgeo_work@126.com</span></p>
        </el-col>
        <el-col :xs="12" :sm="12" class="text-center">
          <p><a>加入团队(<span style="color: #c82333">待开放</span>)</a></p>
        </el-col>
        <el-divider></el-divider>
        <el-col :xs="24" :sm="24" class="text-center">
          <p>如果等到花开的时候，那春天已经到来了！抓住春天的最好机会，就是在"寒冬"</p>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
  export default {
    name: "introduction"
  }
</script>

<style scoped>
  .text-center {
    /*text-align: center;*/
  }

  .text-indent {
    text-indent: 2em;
    line-height: 1.8em;
  }
</style>



// WEBPACK FOOTER //
// src/components/commerical/introduction.vue